import { render, staticRenderFns } from "./AlertSocket.vue?vue&type=template&id=8d4c49a8&scoped=true&"
import script from "./AlertSocket.vue?vue&type=script&lang=js&"
export * from "./AlertSocket.vue?vue&type=script&lang=js&"
import style0 from "./AlertSocket.vue?vue&type=style&index=0&id=8d4c49a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4c49a8",
  null
  
)

export default component.exports